import { styled } from '@mui/material';
import { ReactNode } from 'react';

import { Card } from '@app-velocity/ui';

import { ReportStatistics } from '../../types';
import { SummaryFooter } from './components/SummaryFooter';
import { CompareSummaryWarning } from './types';
import { SummaryHeader } from './components/SummaryHeader';
import { SummaryContent } from './components/SummaryContent';

export type { CompareSummaryWarning, CompareSummaryWarningType } from './types';

export type CompareSummaryCardProps = {
  cardLabel: string;
  title: string;
  subtitle: string;
  statistics: ReportStatistics;
  hideHumanReviews?: boolean;
  warnings?: CompareSummaryWarning[];
  action?: ReactNode;
  index: number;
};

const StyledSummaryCard = styled(Card)({
  display: 'flex',
  flexDirection: 'column',
  padding: 0,
  justifyContent: 'space-between',
  overflow: 'hidden',
});

export const CompareSummaryCard = ({
  cardLabel,
  title,
  subtitle,
  statistics,
  hideHumanReviews = false,
  warnings = [],
  action,
  index,
}: CompareSummaryCardProps) => {
  return (
    <StyledSummaryCard highlighted={index === 0}>
      <SummaryHeader cardLabel={cardLabel} title={title} subtitle={subtitle} />
      <SummaryContent
        statistics={statistics}
        hideHumanReviews={hideHumanReviews}
      />
      <SummaryFooter action={action} warnings={warnings} />
    </StyledSummaryCard>
  );
};
